"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Strings = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_i18next_1 = require("react-i18next");
const en_json_1 = __importDefault(require("../i18n/en.json"));
// takes a json and transforms it recursively into an object that has the same structure
// but 'leaf' nodes' values are their keypaths
const transform = (obj, keyPath) => {
    const strings = Object.keys(obj).reduce((newObj, key) => obj[key] && typeof obj[key] === 'object'
        ? Object.assign(Object.assign({}, newObj), { [key]: transform(obj[key], keyPath ? `${keyPath}.${key}` : key) }) : Object.assign(Object.assign({}, newObj), { [key]: keyPath ? `${keyPath}.${key}` : key }), {});
    Object.defineProperty(strings, 'toString', {
        enumerable: false,
        value: function () {
            return keyPath;
        },
    });
    return strings;
};
exports.Strings = transform(en_json_1.default);
const Localized = (string, options) => {
    return ((0, jsx_runtime_1.jsx)(react_i18next_1.Translation, { "data-e2e": 'Translation', children: () => ((0, jsx_runtime_1.jsx)(react_i18next_1.Trans, Object.assign({ i18nKey: string, tOptions: options, values: options }, options, { "data-e2e": 'Trans', children: "(Localized string not found)" }))) }));
};
exports.default = Localized;
